export const SERVICE_NAME = "Stock-Portal-Client-Logger"
export const METRIC_NAMESPACE = "StockPortal"

export const Units = {
    Count: "Count",
    Milliseconds: "Milliseconds"
}

export const Pages = {
    Dashboard: "Dashboard",
    Broker: "Broker",
    StockAwards: "Stock-Awards",
    FAQs: "FAQs"
}

export const Dimensions = {
    Page: "Page",
    Browser: "Browser",
    Device: "Device",
    JSErrors: "JS-Errors",
    Region: "Region",
    Language: "Language",
    AwardSummaryDownloadType: "Award-Summary-Download-Type"
}

export const MetricNames = {
    PageViews: "Page-Views",
    PageLoadtime: "Page-Loadtime",
    Count: "Count"
}

export const BrowserAndDevice = {
    Browsers: {
        Firefox: "Firefox",
        Edge: "Microsoft-Edge",
        Chrome: "Google-Chrome",
        Safari: "Safari",
        Opera: "Opera",
        Samsung: "Samsung-Internet",
        Unknown: "Unknown-Browser"
    },
    Devices: {
        iPad: "iPad",
        iPhone: "iPhone",
        Android: "Android-Device",
        Macintosh: "Macintosh",
        Windows: "Windows-PC",
        Linux: "Linux-PC",
        Unknown: "Unknown-Device"
    }
}

export const LogThresholds = {
    Info: "info",
    Debug: "debug"
}

export const Stages = {
    Adams: "adams",
    Baker: "baker",
    Alpha: "alpha",
    Beta: "beta",
    Prod: "prod"
}
